import {
  Box,
  Button,
  Chip,
  Typography,
  Grid,
  CircularProgress,
  Tooltip
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import {
  DeleteWorkLocationAction,
  GetWorkLocationAction,
} from "../../../../store/Ancillary/WorkLocation/Action";
import ErrorIcon from '@mui/icons-material/Error';
import party_img from "../../../../Image/party-popper.png";
import work_img from "../../../../Image/working-at-home.png";
import { useDispatch, useSelector } from "react-redux";
import { UpdateConfigureStatusAction } from "../../../../store/Ancillary/ConfigureStatus/Action";
import Popup from "../../Base/views/Popup";
import ValidationPopup from "./ValidationPopup";
import WorkGeoLocationConfig from "../../Ancillary/WorkLocation/views/WorkGeoLocationConfig";
import { Add } from "@mui/icons-material";

const ConfigureWorklocation = ({
  setStepper,
  setTitle,
  setMessage,
  setImageSrc,
}) => {
  const dispatch = useDispatch();

  const { workLocation_options, isAdding, isGetting } = useSelector(
    (state) => state?.AncillaryReducer?.WorkLocationReducer
  );
  const { designation_options } = useSelector(
    (state) => state?.AncillaryReducer?.DesignationReducer
  );
  const [show, setShow] = useState(false);
  const [showContent, setShowContent] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  useEffect(() => {
    dispatch(GetWorkLocationAction());
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Alert = () => {
    const containerStyle = {
      borderRadius: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "5px 5px",
      color: "#000",
      position: "relative",
      marginBottom:"5px",
      width:"40%"
    };
  
    const infoIconStyle = {
      color: "#007bff",
      marginRight: "5px",
      fontSize: "14px",
    };
  
    const textStyle = {
      margin: 0,
      flex: 1,
      color:"#1b1c21",
      fontSize:"12px",
      fontStyle:"italic"
    };
  
    return (
      <div style={containerStyle}>
        <span style={infoIconStyle}><ErrorIcon fontSize="extra-small" /></span>
        <p style={textStyle}>
        Atleast 1 Work Location is required to proceed 
        </p>
      </div>
    );
  };

  const handleFinish = () => {
    if(workLocation_options.length === 0){
      setShow(true);
      setShowContent("You Have to Create Atleast One WorkLocation")
    }
    else if (designation_options.length === 0) {
      setShow(true);
      setShowContent(" You Have to Create Atleast One Designation")
    } else {
      setTitle("And we're all set !");
      setMessage(
        "Quick Tip: As a next step, navigate to Settings > General & Setup your workspace with additional parameters "
      );
      setImageSrc(party_img);
      setStepper(2);
      dispatch(UpdateConfigureStatusAction());
    }
  };
  const handleDelete = (id) => {
    dispatch(DeleteWorkLocationAction({ ats_work_location_id: `{${id}}` }));
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={work_img}
            alt="work_location_name"
            width={"100px"}
            height={"100px"}
          />
          <Typography sx={{ pt: 1, pb: 1 }} variant="h3">
            Where are your offices located at?
          </Typography>
        </Box>
      <Grid container spacing={2} >
        <Grid item xs={12}>
         <Button
            sx={{
              fontWeight: 700,
              fontSize: "13px",
              padding: "4px 10px",
            }}
            startIcon={isAdding ? <CircularProgress size={18} disableShrink /> : <Add />}
            disabled={isAdding}
            size="small"
            variant="contained"
            className="mpl-primary-btn"
            onClick={() => setOpenPopup(true)}
          >
            Add Work Location
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              pt: 1,
              minHeight: "70px",
              maxHeight: "25vh",
              overflowY: "auto",
            }}
          >
            {isGetting ? <CircularProgress size={20} disableShrink /> : workLocation_options?.length === 0 ? <Alert /> : 
              workLocation_options.length > 0 &&
              workLocation_options?.map((name, index) => {
                const isDefault = name?.is_default;
                const isUtilised = name?.is_utitlised;

                const isDeleteDisabled = isDefault || isUtilised;

                const tooltipMessage = isDefault && isUtilised
                  ? "This is a default location and is also mapped to employees"
                  : isDefault
                  ? "This is a default work location and cannot be deleted"
                  : isUtilised
                  ? "This location is mapped to employees and cannot be deleted"
                  : "";

                return (
                  <Tooltip
                    key={index}
                    title={isDeleteDisabled ? tooltipMessage : ""}
                    arrow
                  >
                    <span>
                      <Chip
                        onDelete={
                          !isDeleteDisabled
                            ? () => handleDelete(name?.ats_work_location_id)
                            : undefined
                        }
                        label={`${index + 1}. ${name?.work_location_name}, ${name?.region_name}, ${name?.state_name}`}
                        disabled={isDeleteDisabled}
                        variant="filled"
                        style={{ margin: "0.5rem" }}
                      />
                    </span>
                  </Tooltip>
                );
              })
            }
          </Box>
        </Grid>
      </Grid>
        <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              onClick={() => {
                handleFinish();
              }}
              variant="contained"
              color="primary"
              type="submit"
              className="mpl-primary-btn"
              sx={{
                marginTop: "1.75rem",
                marginRight: "1rem",
                fontSize: "20px",
                padding: "0px 40px 0px 40px",
              }}
            >
              Finish
            </Button>
          
        </div>
      </Box>
      <Popup
        fullWidth={true}
        maxWidth="sm"
        title={"Add Work Location"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <WorkGeoLocationConfig
          editedRecord={null}
          setOpenPopup={setOpenPopup}
        />
      </Popup>
      <Popup maxWidth="xs" openPopup={show} setOpenPopup={setShow}>
      <ValidationPopup openPopup={show} setShow={setShow}  showContent={showContent}/>
      </Popup>
    </>
  );
};

export default ConfigureWorklocation;
